import {
    onUnmounted,
    ref,
    watch,
} from '@vue/composition-api';
import { oddsObserver } from './useElementsVisbilityObserver';

export function useOddObserver() {
    const isObserving = ref(false);
    const observedElementRef = ref<HTMLElement>();

    const { observer, elements: visibleOdds } = oddsObserver();

    watch(() => observedElementRef.value, (val) => {
        if (val && !isObserving.value) {
            observer.observe(val);
            isObserving.value = true;
        }
    });

    onUnmounted(() => {
        if (observedElementRef.value) {
            observer.unobserve(observedElementRef.value);
        }
    });

    return { observedElementRef, visibleOdds };
}
